
























import { Component, Vue, Prop } from "vue-property-decorator";
import SolicitacaoModel, { SolicitacaoDados } from "@/models/Solicitacao";
import { getModule } from "vuex-module-decorators";
import { store, UserModule } from "@/store";
import firebase from "firebase";
import { UserDb } from "@/models/User";
import ProcessosList from "@/components/ProcessosList.vue";
import ProcessoModel, { ProcessoDados, ProcessoUsuariosRef, ParteChaves } from "@/models/Processo";
import _debug from "debug";
import eventBus, { DeclaredEvents, SnackPriorityToColor } from "../../EventBus";

const userModule = getModule(UserModule, store);
const debug = _debug("Mediacao:views:processo:ProcessosTodos.vue");

@Component({
    components: { ProcessosList },
})
export default class Processos extends Vue {
    public carregando = true;
    private processos: ProcessoModel[] = [];
    private emailMediador = "";
    private processosQueryUnsubscribe?: () => void;
    private mostraAtivos = true;

    public editarProcesso(processo: ProcessoModel) {
        debug("Editando o processo:", processo);
        this.$router.push(`/processo/${processo.id}/`);
    }

    public adicionarProcesso() {
        debug("Adicionando processo ...");
        this.$router.push(`/processo/novo/`);
    }

    public async pegarProcesso(processo: ProcessoModel) {
        debug("Pegando processo pra si", processo);
        const user = userModule.getUser;
        processo.setParte(ParteChaves.ParteMediador, user.userDb!.email!);
        await processo.save();
        eventBus.$emit(DeclaredEvents.snackBarMessage, {
            message: "O projeto agora é seu",
            priority: SnackPriorityToColor.success,
        });
        setTimeout(() => {
            this.$router.go(0);
        }, 5000);
    }

    private created() {
        this.carregando = true;
        this.fetchProcessos();
        setTimeout(() => {
            this.carregando = false;
        }, 2000);
        this.emailMediador = userModule.getUser.userDb!.email!;
    }

    private async fetchProcessos() {
        if (this.processos) {
            this.processos.splice(0);
        }
        let filtro = ["aberto", "aberta", "pausado"];
        if (!this.mostraAtivos) {
            filtro = ["encerrado"];
        }
        this.processosQueryUnsubscribe = firebase
            .firestore()
            .collection("processos")
            .where("status", "in", filtro)
            .onSnapshot(
                snapshot => {
                    snapshot.forEach(async doc => {
                        const data = Object.assign(doc.data(), { id: doc.id });
                        await this.addToList(data as ProcessoDados);
                    });
                },
                error => {
                    console.warn("Erro escutando coleção de processos", error);
                },
            );
    }

    private async addToList(processo: ProcessoDados) {
        debug("Vai carregar processo com refs", processo);
        const processoModel = new ProcessoModel(processo, true);
        if (processoModel) {
            processoModel.partesPromise!.then(() => {
                debug("Inserindo processo na lista", processoModel);
                if (
                    !this.processos.some(processoExistente => {
                        return processoExistente.id === processoModel.id;
                    })
                ) {
                    this.processos.push(processoModel);
                }

                this.carregando = false;
            });
        }
    }

    private get botaoFiltro() {
        return this.mostraAtivos ? "Ativos" : "Encerrados";
    }
    private inverterFiltro() {
        if (this.processosQueryUnsubscribe) {
            this.processosQueryUnsubscribe();
            this.fetchProcessos();
        }
    }
}
